import {FormControl,FormLabel,Input,  Button, ButtonGroup , Flex,  Select, Tooltip, useToast } from '@chakra-ui/react'
import { useForm } from "react-hook-form";
import { useState, useEffect } from "react";
import {getDrzave} from '../../util/apiDrzava';




const OsobaStranaView = ({vrstaosobe,stranaosoba,readonly,onSave,onCancel, size='xs'}) => {
    const [drzave,setDrzave]=useState([]);
    const { register, handleSubmit, formState: { errors } } = useForm();
    const toast=useToast();
    const fetchDrzave=async()=>{
        try {
            
            let res=await getDrzave();
            if (res.status===200) {
                setDrzave(res.res);        
                
            } else {
                throw new Error(res.message);
            }
            
        } catch (error) {
            toast({
                title:"Greška kod dohvata podataka.",
                status:"error",
                description:error.message,
                isClosable:true,
                duration:2000,
                position:"top-right",
            });
        }
        
    }
    useEffect(() => {
      fetchDrzave();
    }, [])
    
    const onSubmit = (data, event) => {
        event.preventDefault();
        data.pravna=true;
        if (vrstaosobe==="stranapravna") {
            data.pravna=true;
        }
        if (stranaosoba.id===undefined) {
            data.id=0;
        } else {
            data.id=stranaosoba.id;
        }
        
        onSave(data)
    }
    const onCancelClick=(event)=>{
        onCancel();
    }

    const showDrzave=()=>{
        
        if (drzave.length>0) {
            let _drz="";
            _drz=drzave[0].sifra;
        
        return (
            <FormControl size={size} mb={'1rem'} isReadOnly={readonly}>
            <FormLabel fontSize={size}>Država</FormLabel>
                <Select focusBorderColor='grunt2.400' size={size} variant={'filled'}  maxLength={50} {...register("drzava_sifra")} defaultValue={stranaosoba.drzava_sifra===undefined?_drz:stranaosoba.drzava_sifra}>
                    {drzave.map((item,i)=>{
                        if (item.sifra!=="HR") {
                            return (<option key={i} value={item.sifra}>{item.naziv}</option>)
                        }
                        
                    })}
                </Select>
            </FormControl>
        )
    }
    }
    const ImePrezimeNaziv=()=>{
        if (vrstaosobe==="stranapravna") {
            return (
                <>
                <FormControl mb={'0.5rem'} isInvalid={errors.naziv} isReadOnly={readonly}>
                    <FormLabel fontSize={size}>Naziv</FormLabel>
                    <Tooltip hasArrow label='Polje je obavezno' bg='red' color='white' isDisabled={!errors.naziv}>
                        <Input focusBorderColor='grunt2.400' variant={'filled'} size={size} maxLength={50} {...register("naziv",{required:true})} defaultValue={stranaosoba.naziv}></Input>
                    </Tooltip>
                </FormControl>
                </>
            )
        } 
    }

    const PreventEnter=(e)=>{
        e.keyCode===13 && e.preventDefault();
    }

    return (
        <Flex direction={'column'} scrollBehavior={'auto'}>
        <form onSubmit={handleSubmit(onSubmit)} onKeyDown={PreventEnter}>
        <Input focusBorderColor='grunt2.400' type={'hidden'} {...register("id")}></Input>
        
            
            {ImePrezimeNaziv()}
            <Flex direction={'row'} gap={'0.3rem'}>
            <FormControl mb={'0.5rem'} isInvalid={errors.sifra} isReadOnly={readonly}>
                <FormLabel size={size}>Šifra</FormLabel>
                <Tooltip hasArrow label='Polje je obavezno' bg='red' color='white'  isDisabled={!errors.sifra}>
                    <Input focusBorderColor='grunt2.400' variant={'filled'} size={size} maxLength={10} {...register("sifra",{required:true})} autoCapitalize={'characters'} defaultValue={stranaosoba.sifra}></Input>
                </Tooltip>
            </FormControl>
            </Flex>
            
            <Flex direction={'row'} gap={'0.3rem'}>
            <FormControl mb={'0.5rem'} isReadOnly={readonly}>
                <FormLabel fontSize={size}>Mjesto</FormLabel>
                <Input focusBorderColor='grunt2.400' variant={'filled'} size={size} maxLength={50} {...register("mjesto")} defaultValue={stranaosoba.mjesto}></Input>
            </FormControl>
            <FormControl mb={'0.5rem'} isReadOnly={readonly}>
                <FormLabel fontSize={size}>Ulica i kbr</FormLabel>
                <Input focusBorderColor='grunt2.400' variant={'filled'} size={size} maxLength={50} {...register("ulkbr")} defaultValue={stranaosoba.ulkbr}></Input>
            </FormControl>
            </Flex>
            <Flex direction={'row'} gap={'0.3rem'} >
            <FormControl mb={'0.5rem'} width={'30rem'} isInvalid={errors.pbr} isReadOnly={readonly}>
                <FormLabel fontSize={size}>Poštanski broj</FormLabel>
                <Tooltip hasArrow label='Poštanski broj mora biti dužine 5 znamenaka' bg='red' color='white'  isDisabled={!errors.pbr}>
                    <Input focusBorderColor='grunt2.400' size={size} variant={'filled'}  maxLength={20} {...register("pbr")} defaultValue={stranaosoba.pbr}></Input>
                </Tooltip>
            </FormControl>
            <FormControl mb={'0.5rem'} isReadOnly={readonly}>
                <FormLabel fontSize={size}>Pošta</FormLabel>
                <Input focusBorderColor='grunt2.400' size={size} variant={'filled'}  maxLength={50} {...register("posta")} defaultValue={stranaosoba.posta}></Input>
            </FormControl>
            
            </Flex>
            <Flex direction={'row'} gap={'0.3rem'}>
            {showDrzave()}
            
            </Flex>
            <ButtonGroup gap={'2rem'}>
                {readonly?<></>:<Button type={'submit'} colorScheme={'grunt2'} size={size}>Spremi</Button>}
                <Button colorScheme={'grunt2'} variant={'outline'} size={size} onClick={onCancelClick}>Odustani</Button>
            </ButtonGroup>
        </form>
        </Flex>
    );
}

export default OsobaStranaView;
